// extracted by mini-css-extract-plugin
export default {"content":"Questions_content__RlaIS","img01":"Questions_img01__b5dZD","img02":"Questions_img02__YpuiJ","contentQuestions":"Questions_contentQuestions__qycT3"};